import React, { useState } from 'react';
import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { QuantitySelector } from '../shared/QuantitySelector';
import { ProductAddToCartButton } from '../shared/ProductAddToCartButton';
import { getShopifyID } from '../../utils/utils';
import useProducts from '../../hooks/products/useProducts';
import { ProductAddToProp } from '../../models/ProductPage';

const StyledWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
}));

const SubmitContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    padding: 0,
    button: {
        minHeight: '42px',
        width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: '10px',
    },
}));

export const ProductAddTo: React.FC<ProductAddToProp> = (props) => {
    const { variant, metafields } = props;
    const { t } = useTranslation('product');
    const [qty, setQty] = useState(1);
    const products = useProducts();
    const handleChange = (qty: number) => {
        setQty(qty);
    };

    const getMinQty = (): number => {
        return products.getMinOrderQtyFromMetafields(metafields);
    };

    const getMultiplier = (): boolean => {
        return products.getMultiplierFromMetafields(metafields);
    };

    return (
        <StyledWrapper>
            <Box>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    {t('PRODUCT.QTY')}:
                </Typography>
                <QuantitySelector
                    qtyChanged={handleChange}
                    minOrderQuantity={getMinQty()}
                    minOrderMultiplier={getMultiplier()}
                />
            </Box>
            <SubmitContainer>
                <ProductAddToCartButton
                    variant={Number(getShopifyID(variant.id))}
                    quantity={qty}
                    availableQty={variant.quantityAvailable}
                />
            </SubmitContainer>
        </StyledWrapper>
    );
};
